// Func = limiting Scope for this file
var lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	// submenu
	let itemsMenu = document.querySelectorAll(
		'.privary-navigation .privary-navigation__item',
	)
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			const event = ['mouseenter', 'mouseleave']
			event.forEach((event) => {
				itemMenu.addEventListener(event, () => {
					itemMenu.classList.toggle('hover')
					itemMenu.querySelector('.submenu').classList.toggle('show')
				})
			})
		}
	})

	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll(
			'.burger-menu__mainnav ul li:has(.submenu)',
		)
		let prevMenuItem

		menu_Items.forEach((element) => {
			// active for link generate in js
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			const newListItem = `
				<li class="privary-navigation__item primary-nav-js">
					<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">Overview</a>
				</li>`

			//Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			// active for link generate in js
			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}

			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
					prevMenuItem.classList.remove('active')
				e.target.nextElementSibling.classList.toggle('active')
				prevMenuItem = e.target.nextElementSibling
			})
		})
	}

	// Burger Menu Funcionality Open and Close Menu
	const btn_Menu = document.querySelectorAll('[data-ctaburger]')
	const menu_Section = document.querySelector('[data-menuburger]')
	btn_Menu.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault()
			document.querySelectorAll('.sub-sub-menu.active').forEach((submenu) => submenu.classList.remove('active'))
			menu_Section.classList.toggle('open')
			document.querySelector('body').classList.toggle('no-scroll')
		})
	})

	// booking widget functionality open and close
	const allBookCta = document.querySelectorAll('[data-bookingcta]')
	if (allBookCta) {
		allBookCta.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				document.querySelector('#booking-widget').classList.toggle('open')
				document.body.classList.toggle('no-scroll')
			})
		})
	}
	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	//email signup animation
	const allInputsSignUp = document.querySelectorAll(
		'.email-signup .input input',
	)
	if (allInputsSignUp) {
		allInputsSignUp.forEach((input) => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved')
			})
		})
	}

	//mobile inputs functionality
	if (window.innerWidth <= 768) {
    const inputs = document.querySelectorAll('input[type="date"], input[type="time"]');
    inputs.forEach(input => {

        input.addEventListener("input", function () {
            if (this.value.length > 0) {
                this.classList.add("full"); 
            } else {
                this.classList.remove("full"); 
            }
        });
    });
	}


	/* Change Languages */
	let selectLan = document.getElementById('languages');
	if(selectLan){
		selectLan.addEventListener('change', (e)=>{
			let lang = e.target.value;
			changeLanguage(lang);
		})
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field')

		for (let j = 0; j < allffields.length; j++) {
			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'checkbox' &&
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'radio'
				) {
					allffields[j]
						.getElementsByTagName('input')[0]
						.addEventListener('focus', function () {
							this.parentElement.classList.add('moved')
						})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j]
					.getElementsByTagName('select')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j]
					.getElementsByTagName('textarea')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
		}
	}

	//Video Palms Texture
	const videoTextureGroup = document.querySelector('.video-palms-texture')
	if (videoTextureGroup && window.innerWidth > 900) {
		const videoTexture =
			`<figure id="video-palms-texture">
				<video autoplay muted loop playsinline >
					<source src="${SITE_FILES}/video/video-palms-texture.mp4" type="video/mp4">
				</video>
			</figure>`
		videoTextureGroup.insertAdjacentHTML('beforeend',videoTexture)
	}

	//lightbox form url parameters
	const all_anchors = document.querySelectorAll('a')
	all_anchors.forEach(anchor => {
    const href = anchor.getAttribute('href');
    const match = href && href.match(/[?&]form-lightbox=([^&]+)/);
    
    if (match) {
        const value = decodeURIComponent(match[1]);
        anchor.setAttribute('data-lbx', '');
        anchor.setAttribute('data-lbx-src', value);
    }
	});

	//animation scroll
	const ctas_scroll = document.querySelectorAll('[data-scroll] , .scroll')
	if (ctas_scroll) {
		ctas_scroll.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				const section_to_scroll = new URL(e.target.href)
				if (
					section_to_scroll.href.includes('section#') ||
					section_to_scroll.href.includes('#form_id')
				) {
					let section_to_scroll_id = section_to_scroll.hash.split('#')[1]
					console.log(section_to_scroll_id)
					animateTo(`#${section_to_scroll_id}`)
				} else {
					animateTo(section_to_scroll.hash)
				}
			})
		})
	}

	//cta goto to form
	const ctas_form = document.querySelectorAll('a')
	if (ctas_form) {
		ctas_form.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				const section_to_scroll = new URL(e.target.href)
				if (section_to_scroll.href.includes('#form_id')) {
					e.preventDefault()
					let section_to_scroll_id = section_to_scroll.hash.split('#')[1]
					console.log(section_to_scroll_id)
					animateTo(`#${section_to_scroll_id}`)
				}
			})
		})
	}

let normal_accordion = document.querySelectorAll('[data-accodion] .tab-js');

normal_accordion.forEach((item, i) => {
    item.addEventListener('click', () => {
        item.classList.toggle('active');
        item.nextElementSibling.classList.toggle('active');

        let estaAbierto = item.classList.contains('active');
        item.setAttribute('aria-expanded', estaAbierto ? 'true' : 'false');
    });

    item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            item.click();
        }
    });
});

	// table section
	const tablesResp = document.querySelectorAll('.capacity-chart table')
	if (tablesResp.length) {
		tablesResp.forEach((tablei) => {
			let tableresponsive = document.createElement('div')
			tableresponsive.classList.add('tableHold')
			tablei.parentNode.insertBefore(tableresponsive, tablei)
			tableresponsive.append(tablei)
			const ths = tablei.querySelectorAll('tr:first-child > *')
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td')
				let i = 0
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent)
				}
			})
			const rowHeads = tablei.querySelectorAll('tr td:first-child')
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active')
				})
			})
		})
	}

	// two sliders functionality
	const twoSliders = document.querySelectorAll('.two-sliders')

	twoSliders.forEach((slider) => {
		const sliderCta = slider.querySelectorAll('[data-slidercta]')
		const items = slider.querySelectorAll('.two-sliders__item')

		if (!sliderCta.length || !items.length) return

		sliderCta.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()

				items.forEach((item) => {
					item.classList.toggle('active')
				})
			})
		})
	})

	if (window.location.hash) {
		let headerHeight = document.querySelector('header').offsetHeight + 65;

		if(window.location.hash.includes('events-filter')){
			let dataFilterEvent = (window.location.hash.split('#events-filter-')[1]).replaceAll("-", "+").toUpperCase();
			let quadEvents = document.querySelector('section.events-block');
			document.querySelector(`.events-block__filteritem a[data-event="${dataFilterEvent}"]`).click();
			if(document.querySelector('.events-block__mobileselect select')){
				document.querySelector('.events-block__mobileselect select').value = dataFilterEvent;
				const eventChangeFilter = new Event('change', { bubbles: true });
				document.querySelector('.events-block__mobileselect select').dispatchEvent(eventChangeFilter);
			}
			setTimeout(() => {
				window.scrollTo({
					top: quadEvents.offsetTop - headerHeight,
					behavior: 'smooth'
				});
			}, 500);
		}
		if(document.querySelector(window.location.hash)){
			let target = document.querySelector(window.location.hash);
			setTimeout(() => {
				window.scrollTo({
					top: target.offsetTop - headerHeight,
					behavior: 'smooth'
				});
			}, 500);
		}
	}

	//tabs table funcionality
		document.querySelectorAll('[data-tabmenu]').forEach((btn, i) => {
			btn.addEventListener('click', e => {
					e.preventDefault();
					document.querySelectorAll('[data-tabmenu]').forEach(b => b.classList.remove('active'));
					btn.classList.add('active');
	
					document.querySelectorAll('[data-menu]').forEach(section => {
						section.classList.remove('active');
						if (btn.dataset.tabmenu === section.dataset.menu ) section.classList.add('active');
					});
	
			});
			
			if (i === 0) btn.click()
		});
	
		const select_faq = document.querySelector('[data-menuselect]');
		if (select_faq != null) {
			select_faq.addEventListener('change', e => {
				document.querySelectorAll('[data-menu]').forEach(seccion => {
					seccion.classList.remove('active');
					if (select_faq.value === seccion.dataset.menu) {
						seccion.classList.add('active');
					}
				});
			});
		}

		//custom LBX
		const customLightbox = new LBX('[data-tabs-lightbox]', {});

})()

/* function scrollW() {
	let st = window.pageYOffset || document.documentElement.scrollTop

	if (st > 80) {
		if (st > lastScrollTop) {
			if (!document.getElementById('header' || 'landing-header').classList.contains('down')) {
				document.getElementById('header' || 'landing-header').classList.add('down')
				document.getElementById('header' || 'landing-header').classList.remove('up')
			}
		} else {
			if (!document.getElementById('header' || 'landing-header').classList.contains('up')) {
				document.getElementById('header' || 'landing-header').classList.add('up')
				document.getElementById('header' || 'landing-header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header' || 'landing-header').classList.contains('up') ||
			document.getElementById('header' || 'landing-header').classList.contains('down')
		) {
			document.getElementById('header' || 'landing-header').classList.remove('up', 'down')
		}
	}

	lastScrollTop = st <= 0 ? 0 : st
} */
function scrollW() {
    const header = document.getElementById('header') || document.getElementById('landing-header');

    if (!header) return;

    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > 80) {
        if (st > lastScrollTop) {
            if (!header.classList.contains('down')) {
                header.classList.add('down');
                header.classList.remove('up');
            }
        } else {
            if (!header.classList.contains('up')) {
                header.classList.add('up');
                header.classList.remove('down');
            }
        }
    } else {
        header.classList.remove('up', 'down');
    }

    lastScrollTop = st <= 0 ? 0 : st;
}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.querySelector(target)).top - 50
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1300
	var start = new Date().getTime()
	console.log(gotoTarget)

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)
	}, 1000 / 60)

	window.scrollTo(0, from)
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft,
	}
}

//class for scroll
let classtoscroll = document.querySelectorAll('.scroll-js , .btn-scroll')
if (classtoscroll) {
	classtoscroll.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault()
			let sectiongoto = e.target.hash.split('#')[1]
			animateTo(sectiongoto)
			if (
				document.querySelector('.sub-menu__hold').classList.contains('open')
			) {
				document.querySelector('.sub-menu__hold').classList.remove('open')
			}
		})
	})
}

/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold')
let allsublinks = document.querySelectorAll('.sub-menu a')
if (allsublinks.length > 1) {
	allsublinks.forEach((ele) => {
		ele.addEventListener('click', function (ev) {
			if (ele.classList.contains('active')) {
				ev.preventDefault()
			}
		})
	})
	let toggleBtn = document.querySelector('.sub-menu__toggle')
	if (toggleBtn) {
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.parentElement.classList.add('open')
		toggleBtn.addEventListener('click', function () {
			toggleBtn.parentElement.classList.toggle('open')
		})
	}
} else if (submenuHold.length > 0) {
	submenuHold[0].classList.add('hidden')
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const menu = document.querySelector('.burger-menu')
	const isMenuVisible = menu && menu.classList.contains('open')
	const elements = document.querySelectorAll(
		'.burger-menu .burger-menu__mainnav a, .burger-menu .social-media a',
	)

	elements.forEach((element) => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1')
	})
}
document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex()

	document.addEventListener('focusin', updateMenuTabIndex)
	const menu = document.querySelector('.burger-menu')
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex)
	}
})

const flatpickrLocales = {
    es: {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            longhand: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
        },
        months: {
            shorthand: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            longhand: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        },
        rangeSeparator: " a ",
        time_24hr: true,
    },
    pt: {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
            longhand: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
        },
        months: {
            shorthand: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
            longhand: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        },
        rangeSeparator: " até ",
        time_24hr: true,
    },
    de: {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            longhand: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        },
        months: {
            shorthand: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
            longhand: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        },
        rangeSeparator: " bis ",
        time_24hr: true,
    },
    en: {
        firstDayOfWeek: 0,
        weekdays: {
            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        },
        months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        },
        rangeSeparator: " to ",
        time_24hr: false,
    }
};

function getSiteLocale() {
    const lang = (document.documentElement.lang || 'es').toLowerCase();
    if (lang.startsWith('pt')) return 'pt';
    if (lang.startsWith('de')) return 'de';
    if (lang.startsWith('en')) return 'en';
    return 'es';
}

let isUpdating = false;
let lastAppliedLocale = null;

function applyLocaleToFlatpickr() {
    if (isUpdating) return;
    
    const currentLocale = getSiteLocale();
    
    if (lastAppliedLocale === currentLocale) return;
    
    isUpdating = true;
    const localeConfig = flatpickrLocales[currentLocale];

    if (!localeConfig) {
        isUpdating = false;
        return;
    }

    const elements = document.querySelectorAll('.flatpickr');

    elements.forEach(function (element) {
        if (element._flatpickr) {
            element._flatpickr.set('locale', localeConfig);
        }
    });

    lastAppliedLocale = currentLocale;
    isUpdating = false;
}

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(applyLocaleToFlatpickr, 150);
});

const observer = new MutationObserver(function (mutations) {
    const hasNewElements = mutations.some(function(mutation) {
        return mutation.type === 'childList' && mutation.addedNodes.length > 0;
    });
    
    if (hasNewElements && !isUpdating) {
        lastAppliedLocale = null;
        //setTimeout(applyLocaleToFlatpickr, 200);
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
});